<template>
    <div>
        <h3 class="text-body display-4 montserrat-bold text-uppercase mb-3">SAY HELLO!</h3>
        <div class="row">
            <div class="col-lg-10">
                <form-input placeholder="Name" v-model="form.name" ref="name" alternative></form-input>
            </div>
            <div class="col-lg-10">
                <form-input placeholder="Email" v-model="form.email" ref="email" alternative></form-input>
            </div>
            <div class="col-lg-10">
                <form-input placeholder="Message" v-model="form.message" ref="message" type="textarea" :rows="4" alternative></form-input>
            </div>
            <div class="col-lg-10 text-right">
                <button v-if="!isRequesting" @click="send" class="btn btn-danger">Submit</button>
                <button v-else disabled class="btn btn-danger">
                    <i class="fa fa-spinner fa-spin mr-2"></i> Please wait
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import mixins from "@utils/mixins";
import { route, post } from "@utils/network";

export default {
    name: "ContactUsForm",

    data: () => ({
        isRequesting: false,
        form: {
            name: "",
            email: "",
            message: "",
        }
    }),

    methods: {
        resetForm() {
            this.isRequesting = false;
            this.form = {
                name: "",
                email: "",
                message: "",
            };
        },

        async send() {
            if (!(await this.confirm("Are you sure you want to send this concern?", "")).value) {
                return;
            }
            this.isRequesting = true;
            post(route("contact-us"), { data: this.form })
                .then(response => this.sent(response))
                .catch(error => this.failedToSend(error))
                .finally(() => (this.isRequesting = false));

        },


        sent(response) {
            this.resetForm();
            this.promptSuccess(response.data.message);
        },

        failedToSend(error) {
            console.log(error)
            this.promptFormErrors(this.$refs, error);
        },

    },

    mixins: [mixins],
}
</script>